import JsonLd from './JsonLd';
import { SITE_URL } from './SEOHead';

/**
 * BreadcrumbList JSON-LD for any page.
 *
 * Pass an array of crumbs from root → current page:
 *   <BreadcrumbSchema crumbs={[
 *     { name: 'Home', path: '/' },
 *     { name: 'Shop', path: '/shop' },
 *     { name: product.name, path: `/product/${product.id}` },
 *   ]} />
 *
 * Google uses this to render the breadcrumb trail in search results
 * (replaces the URL line) — improves CTR and signals site structure.
 */
export default function BreadcrumbSchema({ crumbs }) {
  if (!crumbs || crumbs.length === 0) return null;

  const data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: crumb.name,
      item: `${SITE_URL}${crumb.path}`,
    })),
  };

  return <JsonLd id="breadcrumb" data={data} />;
}
